import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";

import leftcamal from "../../../assets/home/leftcamel.png";
import rightcamal from "../../../assets/home/rightcamel.png";
import handPointer from "../../../assets/home/handpointer.png";

const Success = () => {
  return (
    <Box position="relative" bg="#F9E8D4" pt={{ base: 0, md: 0 }} pb={0}>
      {/* Camel Images ABOVE the section */}
      <Box
        position="relative"
        width="100%"
        height={{ base: "100px", md: "100px" }}
      >
        <Image
          src={leftcamal}
          alt="Left Camel"
          position="absolute"
          left="0"
          top={{ base: "340px", md: "320px" }}
          maxW={{ base: "120px", md: "220px" }}
          zIndex={2}
          data-animated="true"
        />
        <Image
          src={rightcamal}
          alt="Right Camel"
          position="absolute"
          right="0"
          top={{ base: "350px", md: "330px" }}
          maxW={{ base: "140px", md: "280px" }}
          zIndex={2}
        />
      </Box>

      {/* Main Heading Section */}
      <Flex
        direction="column"
        align="center"
        textAlign="center"
        zIndex={2}
        position="relative"
        px={{ base: 4, md: 12 }}
        className="fade-in-up"
      >
        <Heading
          as="h2"
          fontSize={{ base: "2xl", md: "4xl" }}
          maxW="4xl"
          fontWeight="bold"
          className="fade-in-up"
        >
          Let’s Turn Your Ideas Into{" "}
          <Text as="span" fontStyle="italic" color="#BFA585" className="fade-in-up">
            Success,
          </Text>{" "}
          One Pixel And Strategy At A Time.
        </Heading>

        <Text
          fontSize={{ base: "md", md: "xl" }}
          mt={4}
          mb={6}
          color="gray.700"
          className="fade-in-up"
        >
          Ready For The{" "}
          <Text as="span" fontStyle="italic" color="#BFA585" className="fade-in-up">
            Digital Panga?
          </Text>
        </Text>

        <Box position="relative" display="">
          <Button
            colorScheme="teal"
            bg="#005a7e"
            color="white"
            px={8}
            py={6}
            borderRadius="xl"
            fontWeight="semibold"
            fontSize={{ base: "sm", md: "md" }}
            _hover={{ bg: "#007ca6" }}
            className="fade-in-up"
          >
            Connect With Us
          </Button>

          {/* Hand Pointer */}
          <Image
            src={handPointer}
            alt="Hand Pointer"
            boxSize={{ base: "25px", md: "30px" }}
            position="absolute"
            zIndex={2}
            right={{ base: "-2", md: "-4" }}
            bottom={{ base: "-2", md: "-4" }}
          />
        </Box>
      </Flex>

      {/* Newsletter Footer Section */}
      <Box
        bg="#BFA585"
        mt={{ base: 24, md: 32 }}
        pt={12}
        pb={16}
        px={{ base: 4, md: 20 }}
        width="100%"
        zIndex={2}
        position="relative"
        color="white"
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          align={{ base: "flex-start", md: "center" }}
          justify="space-between"
          gap={8}
          maxW="1000px"
          mx="auto"
          w="full"
        >
          {/* Text Section */}
          <Box flex="1">
            <Text fontSize="sm" fontWeight="medium" mb={2} className="fade-in-up">
              Join our newsletter to stay up to date on features and releases.
            </Text>
            <Text fontSize="xs" color="whiteAlpha.900" maxW="400px" className="fade-in-up">
              By subscribing you agree to our Privacy Policy and provide consent
              to receive updates from our company.
            </Text>
          </Box>

          {/* Input + Button Section */}
          <Flex
            direction={{ base: "column", md: "row" }}
            align="center"
            gap={4}
            flex="1"
            w="full"
          >
            <Input
              placeholder="Enter your email"
              bg="white"
              color="black"
              borderRadius="md"
              flex="1"
              _placeholder={{ color: "gray.500" }}
              w="full"
            />
            <Box position="relative" display="inline-block">
              <Button
                colorScheme="teal"
                bg="#005a7e"
                color="white"
                px={8}
                py={6}
                borderRadius="xl"
                fontWeight="semibold"
                fontSize={{ base: "sm", md: "md" }}
                _hover={{ bg: "#007ca6" }}
              >
                Subscribe
              </Button>

              {/* Hand Pointer */}
              <Image
                src={handPointer}
                alt="Hand Pointer"
                boxSize={{ base: "25px", md: "30px" }}
                position="absolute"
                right={{ base: "-2", md: "-4" }}
                bottom={{ base: "-2", md: "-4" }}
              />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Success;
